import { render } from "./CambiarCategoriaTicketComponent.vue?vue&type=template&id=1b6c0144"
import script from "./CambiarCategoriaTicketComponent.vue?vue&type=script&lang=js"
export * from "./CambiarCategoriaTicketComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__